import React from "react";
import { ArrowUpRight } from "lucide-react";
import { PROFILE } from "../../data/profile";

export default function Projects() {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative py-24 sm:py-32 border-t border-white/[0.06]"
    >
      <div className="mx-auto max-w-7xl px-5">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <span className="text-eyebrow">// 04 · Featured Projects</span>
            <h2 className="text-display mt-3 text-[2.6rem] sm:text-[3.4rem] leading-[0.95]">
              Things I've <em className="italic text-[var(--jewel)]">shipped</em>.
            </h2>
          </div>
          <p className="text-sm text-muted-foreground max-w-md">
            Real-world projects across AI, Computer Vision, Backend Systems, Cloud and Full-Stack
            development.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 auto-rows-[minmax(0,1fr)] gap-4">
          {PROFILE.projects.map((p, idx) => {
            const span =
              p.span === "wide"
                ? "md:col-span-4"
                : p.span === "tall"
                ? "md:col-span-2 md:row-span-2"
                : "md:col-span-2";
            return (
              <article
                key={p.id}
                data-testid={`project-card-${p.id}`}
                className={`proj-card group relative rounded-2xl border border-white/10 bg-white/[0.025] p-6 overflow-hidden ${span}`}
              >
                {/* hover glow */}
                <div className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-[radial-gradient(400px_200px_at_30%_0%,rgba(212,255,58,0.07),transparent_60%)]" />

                <div className="relative flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl" aria-hidden>
                        {p.icon}
                      </span>
                      <span className="font-mono-ed text-[0.7rem] uppercase tracking-widest text-muted-foreground">
                        {String(idx + 1).padStart(2, "0")} · {p.tag}
                      </span>
                    </div>
                    <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-foreground">
                      {p.name}
                    </h3>
                  </div>
                  <a
                    href={p.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`View ${p.name} on GitHub`}
                    className="shrink-0 mt-1"
                  >
                    <ArrowUpRight
                      size={20}
                      className="text-muted-foreground group-hover:text-[var(--jewel)] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all"
                    />
                  </a>
                </div>

                <p className="relative mt-3 text-sm text-muted-foreground leading-relaxed">
                  {p.desc}
                </p>

                {p.highlights && p.span !== undefined && (
                  <ul className="relative mt-4 space-y-1.5 text-sm text-foreground/75">
                    {p.highlights.slice(0, p.span === "tall" ? 4 : 2).map((h) => (
                      <li key={h} className="flex gap-2">
                        <span className="text-[var(--jewel)] mt-1">›</span>
                        <span>{h}</span>
                      </li>
                    ))}
                  </ul>
                )}

                <div className="relative mt-5 flex flex-wrap gap-1.5">
                  {p.stack.map((s) => (
                    <span key={s} className="pill">
                      {s}
                    </span>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
